import { Close } from '@mui/icons-material';
import { Dialog, DialogTitle, IconButton, useMediaQuery, useTheme } from '@mui/material';

export function BaseDialog({ open, onClose, children, title, ...props }) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            fullScreen={isSmallScreen}
            open={open}
            onClose={onClose}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 4,
                },
            }}
            {...props}
        >
            <DialogTitle>
                {title}
                <IconButton
                    onClick={onClose}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            {children}
        </Dialog>
    );
};
